const CrossCircleIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props} className={`${props?.fill ?? 'fill-current'} ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_70275_69864)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.33398 7.9987C1.33398 11.6807 4.31865 14.6654 8.00065 14.6654C11.6827 14.6654 14.6673 11.6807 14.6673 7.9987C14.6673 4.3167 11.6827 1.33203 8.00065 1.33203C4.31865 1.33203 1.33398 4.3167 1.33398 7.9987ZM11.7719 11.7699C10.7717 12.7701 9.41514 13.332 8.00065 13.332C6.81026 13.332 5.6609 12.9341 4.73044 12.2118L12.2138 4.72849C12.936 5.65894 13.334 6.80831 13.334 7.9987C13.334 9.41319 12.7721 10.7697 11.7719 11.7699ZM11.271 3.78567L3.78762 11.269C3.06531 10.3385 2.66732 9.18914 2.66732 7.9987C2.66732 6.58421 3.22922 5.22766 4.22941 4.22746C5.22961 3.22727 6.58616 2.66536 8.00065 2.66536C9.19109 2.66536 10.3405 3.06336 11.271 3.78567Z" />
    </g>
    <defs>
    <clipPath id="clip0_70275_69864">
    <rect width="16" height="16" fill="white"/>
    </clipPath>
    </defs>
  </svg>
);

export default CrossCircleIcon;
